import { writable } from "svelte/store";

let messages = [];

let { subscribe, update } = writable(messages);

let deleteByHash = h => update(messages => {
    messages.forEach((m,idx) => {
        if (h == m.hash) {
            messages.splice(idx,1);
        }        
    });

    return messages;
});

let setDeleteTimer = hash =>  {
   
    setTimeout(() => {
        deleteByHash(hash);
    }, 5000);    
};

let add = message => update(messages => {    

    if (message.timed === true) {
        setDeleteTimer(message.hash);           
    }
    return[...messages,message];    
});

export default {
    subscribe,
    add,
    deleteByHash
}

